const { h, render, Component } = require('preact');
const SignInSignUpBannerView = require('../../views/main/sign_in_sign_up')

class SignInSignUpBanner extends Component {
  constructor(props) {
    super(props);
    this.getHelpText = this.getHelpText.bind(this);
    this.getSignInUrl = this.getSignInUrl.bind(this);
    this.getGuestCheckoutURL = this.getGuestCheckoutURL.bind(this);
    this.configFromDom = Groupon.Utils.getConfigFromDom();
  }

  getHelpText(){
    if (this.configFromDom && this.configFromDom.isRegionNAandBrandGroupon)
      return I18n.translate("js.modules.web_2018.get_help_groupon")
    else
      return I18n.translate("js.modules.web_2018.get_help_livingsocial")
  }

  getSignInUrl() {
    if (this.configFromDom && this.configFromDom.SUPPORTBASEURL)
      return `/login?return_to=${ encodeURIComponent(this.configFromDom.SUPPORTBASEURL) }`
  }

  getGuestCheckoutURL(){
    if (this.configFromDom && this.configFromDom.SUPPORTBASEURL)
      return `${this.configFromDom.SUPPORTBASEURL}/web/guest`
  }

  render() {
    return (
      <SignInSignUpBannerView
        getHelpText = {this.getHelpText}
        getSignInUrl = {this.getSignInUrl}
        getGuestCheckoutURL = {this.getGuestCheckoutURL}
      />
    );
  }
}
module.exports = SignInSignUpBanner
